import type * as React from 'react';
import { Toaster as SonnerToaster, toast } from 'sonner';

/**
 * Toasts.
 *
 * `sonner` is re-exported rather than wrapped so a consumer imports `toast` from
 * `@crm/ui` and can never end up with two Toaster registries (one from the app's
 * own `sonner` copy, one from ours) — a failure mode where half the toasts are
 * simply never rendered.
 */
export { toast };

export type ToasterProps = React.ComponentProps<typeof SonnerToaster>;

export function Toaster(props: ToasterProps) {
  return (
    <SonnerToaster
      position="bottom-right"
      closeButton
      toastOptions={{
        classNames: {
          toast: 'border border-border bg-popover text-popover-foreground shadow-lg',
          description: 'text-muted-foreground',
          actionButton: 'bg-primary text-primary-foreground',
          cancelButton: 'bg-muted text-muted-foreground',
        },
      }}
      {...props}
    />
  );
}
